import { render, staticRenderFns } from "./common-volume-library.vue?vue&type=template&id=683976bd"
import script from "./common-volume-library.vue?vue&type=script&lang=js"
export * from "./common-volume-library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports